import {
  Table,
  TableCell,
  TableContainer,
  TableHeader,
} from "@windmill/react-ui";

import PartialPaymentTable from "components/partialpayment/PartialPaymentTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";

import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useEffect } from "react";
import PartialPaymentServices from "services/PartialPaymentServices";

import PartialPaymentDrawer from "components/drawer/PartialPaymentDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";

import sidebar from "routes/sidebar";

const PartialPayment = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const { data, loading, error } = useAsync(
    PartialPaymentServices.getAllPartialPayment
  );

  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tab] = useState(0);
  const [partialpaymentData, setPartialPaymentData] = useState([]);
  const [status, setStatus] = useState(false);
  const {
    dataTable,
    serviceData,

    currentPage,
  } = useFilter(partialpaymentData, itemsPerPage);
      useEffect(() => {
    if (dataTable.length !== 0) {
      setItemsPerPage(dataTable.length);
    }
  }, [dataTable]);

  useEffect(() => {
    if (data) {
      const responseData = data?.data || [];

      if (Array.isArray(responseData)) {
        // If responseData is an array, process it directly
        const updatedData = responseData.map(
          ({ id, more_than_24, less_than_24, ...rest }) => ({
            id,
            more_than_24,
            less_than_24,
            ...rest,
          })
        );
        setPartialPaymentData(updatedData);
      } else if (responseData && typeof responseData === "object") {
        // If responseData is a single object, wrap it in an array
        const updatedData = [
          {
            id: responseData.id,
            more_than_24: responseData.more_than_24,
            less_than_24: responseData.less_than_24,
            ...responseData,
          },
        ];
        setPartialPaymentData(updatedData);
      } else {
        console.error("Expected an array or an object but got:", responseData);
      }
    } else {
      console.error("Data is null or undefined");
    }
  }, [data]);

   useEffect(() => {
            if (data?.status) {
              setStatus(data.status);
            } else {
              setStatus(false);
            }
          }, [data?.status]);

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "partial payment" && perm.view === 1
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "partial payment" && perm.edit === 1
      );

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <MainDrawer>
            <PartialPaymentDrawer id={serviceId} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />
             <DataWrapper loading={loading} error={error} status={status}>
          { serviceData?.length !== 0 ? (
            <TableContainer
              className="mb-8 overflow-y-scroll"
              style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
            >
              <Table>
                <TableHeader className="capitalize text-center sticky top-0 z-10 text-sm">
                  <tr>
                    <TableCell>Sl.No.</TableCell>
                    <TableCell>More than 24 hrs</TableCell>
                    <TableCell>less than 24 hrs</TableCell>
                    <TableCell>Actions</TableCell>
                  </tr>
                </TableHeader>
                <PartialPaymentTable
                  partialpayment={dataTable}
                  perpage={itemsPerPage}
                  currentPage={currentPage}
                  tab={tab}
                  hideEdit={hideEdit}
                />
              </Table>
            </TableContainer>
          ) : (
                <NotFound title="There are no Partial payment." />
          )}{" "}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default PartialPayment;
